export default __webpack_public_path__ + "static/media/empty-betslip.d5acb5b1.png";